export const getAccessibleToStudentsOptions = () => [
  {label: 'Yes', value: 'true'},
  {label: 'No', value: 'false'},
];
